import { Grid } from '@material-ui/core';
import moment from 'moment-timezone';
import React from 'react';

// TODO: DEPRECATE THIS. DO NOT ADD TO THIS FILE.

// CDate, Crevenue, etc represent the compare data
export interface IDataItem {
  Date?: moment.Moment | string;
  CDate?: moment.Moment | string;
  DateLabel?: string;
  Revenue?: number;
  RevenueAgg?: number;
  CRevenueAgg?: number;
  RevenueLive?: number;
  CRevenueLive?: number;
  CRevenue?: number;
  Impressions?: number;
  CImpressions?: number;
  CPM?: number;
  CCPM?: number;
  CPMPerSecond?: number;
  CCPMPerSecond?: number;
  EndpointRequests?: number;
  CEndpointRequests?: number;
  FillRate?: number;
  CFillRate?: number;
  PodFillRate?: number;
  CPodFillRate?: number;
  PodClearRate?: number;
  CPodClearRate?: number;
  PaidPodClearRate?: number;
  CPaidPodClearRate?: number;
  EndpointRequestECPM?: number;
  CEndpointRequestECPM?: number;
  RenderRate?: number;
  CRenderRate?: number;
  BidResponses?: number;
  CBidResponses?: number;
  BidRequests?: number;
  CBidRequests?: number;
  BidResponseRate?: number;
  CBidResponseRate?: number;
  BidTimeoutsRate?: number;
  CBidTimeoutsRate?: number;
  WinningBids?: number;
  CWinningBids?: number;
  Time?: string;
  [key: string]: any;
}

export type IGraphDataTypes = Record<string, { color: string; title: string }>;

export const MakeDot = (color: string, opacity = 1) => {
  return (
    <Grid
      item
      style={{
        backgroundColor: `${color}`,
        borderRadius: 99,
        height: 10,
        width: 10,
        opacity,
      }}
    />
  );
};

export const MakeDashes = (color: string, opacity = 1) => {
  return (
    <Grid
      item
      style={{
        border: `none`,
        borderTop: `3px dotted ${color}`,
        marginTop: 8,
        height: 1,
        width: 15,
        opacity,
      }}
    />
  );
};
